import { useMemo } from "react";
import CampaignIcon from "@mui/icons-material/Campaign";
import ShareIcon from "@mui/icons-material/Share";
import AddToDriveIcon from "@mui/icons-material/AddToDrive";
import { FolderInput } from "lucide-react";
import ButtonMenu from "../../Buttons/ButtonMenu";
import {
  BUTTON_IMPORT_FROM_PLATFORM,
  BUTTON_CREATE_WITH_CANVA,
  GALLERY_SOURCE_GOOGLE_DRIVE,
  GALLERY_SOURCE_AD_ACCOUNT,
  GALLERY_SOURCE_SOCIAL_POSTS,
  GALLERY_SOURCE_CANVA,
} from "../../../i18n/keysTranslations";
import { logoPlatform } from "../../../utils/string";
import { CANVA } from "../../../utils/constants";

const menuIconSx = { fontSize: 16, mr: 1 };

const canvaMenuIcon = (
  <img
    src={logoPlatform(CANVA)}
    alt=""
    style={{ width: 20, height: 20, marginRight: 8 }}
  />
);

const ImportDropdownButton = ({
  showGoogleDriveOption = true,
  showAdAccountOption = true,
  showSocialPostsOption = true,
  hasAdAccountIntegration = false,
  hasMetaIntegration = false,
  isLoadingGoogleDrivePicker = false,
  isUploading = false,
  isLoadingSource = false,
  onCreateWithCanva = () => {},
  onImportFromGoogleDrive = () => {},
  onImportFromAdAccount = () => {},
  onImportFromSocialPosts = () => {},
  onImportFromCanvaGallery = () => {},
  sx = {},
}) => {
  const options = useMemo(() => {
    const menuOptions = [
      {
        label: BUTTON_CREATE_WITH_CANVA,
        icon: canvaMenuIcon,
        onClick: onCreateWithCanva,
        disabled: isLoadingSource,
      },
    ];

    if (showGoogleDriveOption) {
      menuOptions.push({
        label: GALLERY_SOURCE_GOOGLE_DRIVE,
        icon: <AddToDriveIcon sx={menuIconSx} />,
        onClick: onImportFromGoogleDrive,
        disabled: isLoadingGoogleDrivePicker || isUploading,
      });
    }

    if (showAdAccountOption && hasAdAccountIntegration) {
      menuOptions.push({
        label: GALLERY_SOURCE_AD_ACCOUNT,
        icon: <CampaignIcon sx={menuIconSx} />,
        onClick: onImportFromAdAccount,
        disabled: isLoadingSource,
      });
    }

    if (showSocialPostsOption && hasMetaIntegration) {
      menuOptions.push({
        label: GALLERY_SOURCE_SOCIAL_POSTS,
        icon: <ShareIcon sx={menuIconSx} />,
        onClick: onImportFromSocialPosts,
        disabled: isLoadingSource,
      });
    }

    menuOptions.push({
      label: GALLERY_SOURCE_CANVA,
      icon: canvaMenuIcon,
      onClick: onImportFromCanvaGallery,
      disabled: isLoadingSource,
    });

    return menuOptions;
  }, [
    showGoogleDriveOption,
    showAdAccountOption,
    showSocialPostsOption,
    hasAdAccountIntegration,
    hasMetaIntegration,
    isLoadingGoogleDrivePicker,
    isUploading,
    isLoadingSource,
    onCreateWithCanva,
    onImportFromGoogleDrive,
    onImportFromAdAccount,
    onImportFromSocialPosts,
    onImportFromCanvaGallery,
  ]);

  return (
    <ButtonMenu
      mode="button"
      colorButton="secondary"
      textButton={BUTTON_IMPORT_FROM_PLATFORM}
      options={options}
      disabled={isUploading}
      iconButton={<FolderInput size={19} style={{ marginRight: 10 }} />}
      sx={sx}
    />
  );
};

export default ImportDropdownButton;
